import { firebase } from "../firebase/firebase";
import createUID from "../functions/createUID";

export const imageUpload = (images, path) => {
  return dispatch => {
    Promise.all(Array.from(images).map(file => putStorageItem(file)))
      .then(() => {
        dispatch({
          type: "IMAGE_URL_STATUS",
          done: true,
        });
      })
      .catch(err => {
        alert("Some failed: " + err.message);
      });

    function putStorageItem(item) {
      console.log(item);
      return firebase
        .storage()
        .ref(path + createUID())
        .put(item)
        .then(snapshot => {
          dispatch({
            type: "IMAGE_URL",
            url: snapshot.downloadURL,
          });
        })
        .catch(err => {
          alert("One failed:" + item + err);
        });
    }
  };
};

export const imageInit = () => {
  return dispatch => {
    dispatch({
      type: "IMAGE_INIT",
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/imageActions.js